module.exports = __webpack_public_path__ + "img/intp.307a6349.png";